import {SimpleFilterOption} from '@bmc-ux/adapt-angular';
import {FEEDBACK_FORM_TYPE, FEEDBACK_SOURCE} from './feedback';

export enum FEEDBACK_TABLE_TYPE {
  ALL = 'ALL',
  ALL_ADMIN = 'ALL_ADMIN',
  ALL_CLIENT = 'ALL_CLIENT',
  BY_SN_ALL = 'BY_SN_ALL',
  BY_SN_ADMIN = 'BY_SN_ADMIN',
  BY_SN_CLIENT = 'BY_SN_CLIENT',
}

export const FEEDBACK_COLUMN_CONFIG = {
  TYPE: {
    header: 'Type',
    field: 'feedbackType',
    editable: false,
    width: '85px'
  },
  DATE: {
    header: 'Date',
    field: 'voteTime',
    width: '100px',
  },
  MESSAGE: {
    header: 'Message',
    field: 'message',
  },
  DESCR: {
    header: 'Description',
    field: 'shortDescription',
    width: '130px',
  },
  AUTHOR: {
    header: 'Author',
    field: 'author',
  },
  LINK: {
    header: 'Link',
    field: 'pageLink',
  },
  SN: {
    header: 'SN',
    field: 'smartNumber',
    width: '120px'
  },
  PRODUCT_NAME: {
    header: 'Product',
    field: 'productName'
  },
  VERSION: {
    header: 'Version',
    field: 'productVersion',
    width: '100px',
  },
  SP_NAME: {
    header: 'SP/FP/Patch',
    field: 'servicePackName',
    width: '130px',
  },
  MACRO_TYPE: {
    header: 'Macro Type',
    field: 'description',
    width: '140px'
  },
  SOURCE_OR_MACRO_TYPE: {
    header: 'Source/Macro Type',
    field: 'description',
  },
  SOURCE: {
    header: 'Source APP',
    field: 'feedbackSource'
  }
};

export interface SimpleFilterKey2FilterOptions {
  [key: string]: SimpleFilterOption;
}

export enum FEEDBACK_SIMPLE_FILTER_KEY {
  SOURCE_APP = 'SOURCE_APP',
  FEEDBACK_TYPE = 'FEEDBACK_TYPE'
}

export const FEEDBACK_SIMPLE_FILTER_OPTIONS: {[key: string]: SimpleFilterOption[]} = {
  SOURCE_APP: [
    { label: 'Admin', id: FEEDBACK_SOURCE.ADMIN, data: {field: 'feedbackSource'} },
    { label: 'Client', id: FEEDBACK_SOURCE.CLIENT, data: {field: 'feedbackSource'} }
  ],
  FEEDBACK_TYPE: [
    { label: 'Positive', id: FEEDBACK_FORM_TYPE.POSITIVE, data: {field: 'feedbackType'} },
    { label: 'Negative', id: FEEDBACK_FORM_TYPE.NEGATIVE, data: {field: 'feedbackType'} }
  ]
};
